import { render, staticRenderFns } from "./PropertiesPage.vue?vue&type=template&id=29f03434&lang=true"
import script from "./PropertiesPage.vue?vue&type=script&lang=js"
export * from "./PropertiesPage.vue?vue&type=script&lang=js"
import style0 from "./PropertiesPage.vue?vue&type=style&index=0&id=29f03434&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports